import HttpRequest from '../../util/HttpRequest'
import constant from '@/constant/constant'

export default {

  /**
   * 회사 목록
   * @params {page, perPage}
   */
  async LOAD_COMPANY_LIST ({commit}, params) {

    const option = {
      params: {
        page: params.page,
        perPage: params.perPage,
        keyword: params.keyword
      }
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/company', option)
        .then(response => {

          // mutations 메소드 호출
          commit('LOAD_COMPANY_LIST', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async LOAD_COMPANY ({commit}, params) {
    const companyId = params.companyId

    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/company/${companyId}`)
        .then(response => {

          // mutations 메소드 호출
          commit('LOAD_COMPANY', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async LOAD_MEMBER_LIST ({commit}, params) {

    const option = {
      params: {
        page: params.page,
        perPage: params.perPage,
        company_id: params.company_id
      }
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/company/member', option)
        .then(response => {

          // mutations 메소드 호출
          commit('LOAD_MEMBER_LIST', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  }
}
